module.exports = __webpack_public_path__ + "541385d35dd90b6368dac3436004687a.png";